export default "__VITE_ASSET__1dC4QY2H__"